package com.ai.mitra.utils

const val BASE_URL = "https://generativelanguage.googleapis.com/"
const val DB_NAME = "GeminiApiChatDB.db"
const val GEMINI_PRO = "gemini-1.5-flash"
const val GEMINI_PRO_VISION = "gemini-1.5-flash"
enum class TYPE{
    MOBILE,
    DESKTOP,
    WEB,
}

enum class Screens{
    MAIN,
    DETAIL
}